var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMrwolfBlackSimple160(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 0C40 0 20.2208 2.57928 11.4 11.4001C2.5792 20.2209 0 40 0 80C0 120 2.5792 139.779 11.4 148.6C20.2208 157.421 40 160 80 160C120 160 139.779 157.421 148.6 148.6C157.421 139.779 160 120 160 80C160 40 157.421 20.2209 148.6 11.4001C139.779 2.57928 120 0 80 0ZM80.0002 65.1129L21.7305 39.5059L25.3163 74.7186H34.8265L32.8574 54.5798L80.0002 75.0614V65.1129ZM80.0039 65.1129L138.274 39.5059L134.688 74.7186H125.177L128.133 54.5798L80.0039 75.0614V65.1129ZM80.0002 94.8867L21.7305 120.494L25.3163 85.281H34.8265L32.8574 105.42L80.0002 84.9382V94.8867ZM80.0039 94.8867L138.274 120.494L134.688 85.281H125.177L127.147 105.42L80.0039 84.9382V94.8867Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrwolfBlackSimple160);
export default __webpack_public_path__ + "static/media/mrwolf-black-simple-160.cee4afa0568cc42667fc0959ec0e56f1.svg";
export { ForwardRef as ReactComponent };